import React from "react";
import { CustomerConfirmationData } from "../../../types/CustomerConfirmation";
import greenTick from "../../../images/icon--greenTick-clearCircle.svg";

export const CustomerConfirmationDetails = ({
  title,
  subtitle,
  onSubmit,
  buttonCopy,
  analyticsLabel
}: CustomerConfirmationData) => {
  return (
    <div className="ch-display--flex ch-flex-flow--column-nowrap ch-align-items--center ch-text--center">
      <img
        className="customer-confirmation--icon-success ch-mb--2"
        src={greenTick}
        alt="Success: green tick icon"
      />
      <div className="ch-mb--1">
        <p className="ch-fs--4 ch-fw--500 ch-mb--1">{title}</p>
        {subtitle && <p className="ch-fs--3 ch-mb--1">{subtitle}</p>}
      </div>
      <button
        className="ch-btn ch-btn--success ch-width--10"
        onClick={onSubmit}
        data-gtm-track="click_cta"
        data-gtm-track-label={analyticsLabel}
      >
        {buttonCopy}
      </button>
    </div>
  );
};
